import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

interface SocketStore {
  maxRetryCount?: number
  timeToFailConnection?: string
  timeToOpenConnection?: string
  setTimeToOpenConnection(timeToOpenConnection: string): void
  setTimeToFailConnection(timeToFailConnection: string): void
  setMaxRetryCount(maxRetryCount: number): void
}

export const useSocketStore = create<SocketStore>()(
  devtools(
    (set) => ({
      maxRetryCount: 0,
      setTimeToOpenConnection(timeToOpenConnection) {
        set({ timeToOpenConnection })
      },
      setTimeToFailConnection(timeToFailConnection) {
        set({ timeToFailConnection })
      },
      setMaxRetryCount(maxRetryCount) {
        set({ maxRetryCount })
      }
    }),
    { name: 'SSEStore' }
  )
)
